import { ReactNode } from 'react'

import { AlertStatus } from '@/gen/inventory/v1/alert_pb'

import { alertStatusLabel } from '@/const/label'

import { StatusConfig } from '@/hooks/use-status-selector'

import { AlertStatusIcon } from '@/components/shared/icons/alert-status'
import { MenuItem } from '@/components/shared/submit-select/types'

import { SELECT_ALERT_STATUS_BADGE_LABELS } from './labels'

const alertLabelToStatus: Record<string, AlertStatus> = {
  [alertStatusLabel[AlertStatus.RESOLVED]]: AlertStatus.RESOLVED,
  [alertStatusLabel[AlertStatus.ACCEPTED]]: AlertStatus.ACCEPTED,
  [alertStatusLabel[AlertStatus.ONGOING]]: AlertStatus.ONGOING,
  [alertStatusLabel[AlertStatus.OPEN]]: AlertStatus.OPEN,
  [alertStatusLabel[AlertStatus.NOT_APPLICABLE]]: AlertStatus.NOT_APPLICABLE,
  [alertStatusLabel[AlertStatus.UNSPECIFIED]]: AlertStatus.UNSPECIFIED,
}

// alertStatusSelectorConfig is used as a group of helper functions to pass to the useStatusSelector hook
// these helper functions populate the correct items for the alert status menu items,
// provides the correct icons, labels and readOnly state.
export const alertStatusSelectorConfig: StatusConfig<AlertStatus> = {
  statusEnum: alertLabelToStatus,
  statusLabels: alertStatusLabel,

  getStatusIcon: (status: AlertStatus): ReactNode => <AlertStatusIcon status={status} />,

  isStatusReadOnly: (status: AlertStatus): boolean => {
    return (
      status === AlertStatus.RESOLVED ||
      status === AlertStatus.ACCEPTED ||
      status === AlertStatus.NOT_APPLICABLE
    )
  },

  getMenuItems: (
    currentStatus: AlertStatus,
    createBadge: (status: AlertStatus) => ReactNode,
    isFalsePositive: boolean,
  ): MenuItem<AlertStatus>[] => {
    const warningMessage = isFalsePositive
      ? SELECT_ALERT_STATUS_BADGE_LABELS.falsePositiveWarning
      : ''

    return [
      {
        type: 'menuSelectItem',
        label: createBadge(AlertStatus.OPEN),
        value: AlertStatus.OPEN,
        disabled: currentStatus !== AlertStatus.OPEN,
      },
      {
        type: 'menuSelectItem',
        label: createBadge(AlertStatus.ONGOING),
        value: AlertStatus.ONGOING,
      },
      {
        type: 'menuSelectItem',
        label: createBadge(AlertStatus.NOT_APPLICABLE),
        value: AlertStatus.NOT_APPLICABLE,
        warningMessage,
      },
      {
        type: 'menuSelectItem',
        label: createBadge(AlertStatus.ACCEPTED),
        value: AlertStatus.ACCEPTED,
        warningMessage,
      },
      {
        type: 'menuSelectItem',
        label: createBadge(AlertStatus.RESOLVED),
        value: AlertStatus.RESOLVED,
        warningMessage,
      },
    ]
  },
}
